import OperatorInfo from "./OperatorsInfo";

export default OperatorInfo;